// src/components/PinisiKata/PinisiLevelScreen.js
import React from 'react';
import styles from './PinisiKata.module.css';
import KalselMapSVG from './KalselMapSVG'; // Impor komponen peta
import { ACTIONS } from './PinisiKataGame'; // Impor Aksi

// --- Konfigurasi Data Level ---
// Menempatkan data di sini membuatnya mudah untuk diubah.
const LEVELS_DATA = [
    {
        id: 1,
        name: "RIMBA KATA PEMULA",
        description: "Level dasar untuk pemula",
        questionCount: 10,
    },
    {
        id: 2,
        name: "SAMUDERA MAKNA",
        description: "Level menengah yang menantang",
        questionCount: 15,
    },
    {
        id: 3,
        name: "PUNCAK WAWASAN KEBAHASAAN",
        description: "Level lanjutan untuk ahli",
        questionCount: 20,
    },
];

/**
 * Komponen PinisiLevelScreen menampilkan peta dan daftar level yang bisa dipilih.
 * @param {object} props
 * @param {function} props.dispatch - Fungsi dispatch dari useReducer untuk mengirim aksi.
 */
function PinisiLevelScreen({ dispatch }) {
    
    // Fungsi untuk menangani klik pada sebuah level
    const handleLevelSelect = (levelId) => {
        // Di sini Anda bisa menambahkan logika lain seperti memainkan suara
        dispatch({ type: ACTIONS.SELECT_LEVEL, payload: { level: levelId } });
    };

    // Fungsi untuk kembali ke layar utama
    const handleGoBack = () => {
        dispatch({ type: ACTIONS.GO_TO_SCREEN, payload: { screen: 'start' } });
    };

    return (
        <div className={`${styles.screen} ${styles.levelSelectScreen} ${styles.active}`}>
            {/* Tombol Kembali, selalu terlihat di pojok */}
            <button className={styles.backButton} onClick={handleGoBack} title="Kembali">
                ←
            </button>

            {/* Peta Kalsel sebagai elemen visual */}
            <div className={styles.mapContainer}>
                <KalselMapSVG className={styles.kalselMap} />
            </div>

            <h2 className={styles.levelTitle}>PILIH LEVEL PETUALANGAN</h2>

            <div className={styles.levelButtons}>
                {/* Render tombol level secara dinamis dari data */}
                {LEVELS_DATA.map((level) => (
                    <button 
                        key={level.id}
                        className={styles.levelButton} 
                        onClick={() => handleLevelSelect(level.id)}
                    >
                        <div className={styles.levelInfo}>
                            <div className={styles.levelName}>{level.name}</div>
                            <div className={styles.levelDescription}>{level.description}</div>
                        </div>
                        <span className={styles.questionCount}>{level.questionCount} Soal</span>
                    </button>
                ))}
            </div>
        </div>
    );
}

export default PinisiLevelScreen;